import { useEffect, useState } from 'react';
export function useExpandedText() {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    const measure = () =>
      setExpanded(
        parseFloat(getComputedStyle(document.documentElement).fontSize) >= 16 * 1.4 - 0.000001,
      );
    measure();
    const observer = new MutationObserver(measure);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);
  return expanded;
}
